import { connect } from 'socket.io-client';
import ConsoleParent from './consoleParent';
import ConsoleUI from './consoleUI';
import Socket = SocketIOClient.Socket;


class ConsoleRCon extends ConsoleParent {

    private lastCall: number = Date.now();
    protected max_allowed_calls_interval: number = 1000;
    protected console: Socket;

    protected initUi(el: JQuery): void {
        this.ui = new ConsoleUI(el);
        this.ui.setConnectionStatus(true);
    }

    protected initConsole(url: string): void {
        this.console = connect(url,
            {
                reconnectionAttempts: 7,
                reconnectionDelayMax: 7000,
                randomizationFactor: 0.7,
                query: {gameserver_id: window.gameserverId},
                path: `/${window.regionPrefix}/ws/console/socket.io`,
                transports: ['websocket', 'polling']
            }
        );

        this.console.on('connect', () => {
            this.console.on('meta', (message) => {
                this.writeToConsole(message, 'row-meta');
            });

            this.console.on('output', this.onOutPutHandler);

            this.ui.onSubmit(this.submit.bind(this));
        });
    }

    onOutPutHandler = (message) => {
        this.writeToConsole(message);
    }

    protected submit(text: string): void {
        let now = Date.now();
        if (this.lastCall + this.max_allowed_calls_interval > now) {
            this.writeToConsole('Limit reached, please try again!');
            return;
        }
        this.lastCall = now;
        this.console.send(btoa(text));
        this.ui.clearInput();
    }

    protected writeToConsole(message: string, clazz = 'row-standard'): void {
        this.ui.writeToConsole(atob(message), clazz);
    }
}

export default ConsoleRCon;
